














import Vue, { PropType } from 'vue';
import {
  Entry,
  PublicBuyer,
  PublicBuyerCompany,
  PublicExhibition,
  PublicOffline,
  PublicOfflineDay,

  PublicExhibitor,
  PublicExhibitorCompany,

} from 'mostra';

// import contact, { Contact } from '@/modules/contact/contact';
// import message, { Message } from '@/modules/contact/message';

// import exhibitor from '@/modules/exhibitor/exhibitor';
// import companyExhibitor from '@/modules/exhibitor/company';
// import brand, { Brand } from '@/modules/exhibitor/brand';

// import {
//   publicExhibitor as exhibitor,
//   publicExhibitorCompany as companyExhibitor,
//   publicBrand as brand,
//   PublicBrand as Brand,
// } from 'mostra';
//
// import {
//   genDownloadImageUrlByImage,
//   // genDownloadImageUrlsByImage,
//   sizes,
// } from '@/modules/image';

// import {
//   genDownloadOriginalImageUrlEx,
//   genDownloadOriginalImageUrlByImageEx,
// } from '@/modules/image';

// interface DataType {
//   exhibitorUID: string;
//   exhibitorCID: string | null;
//   buyerCID: string | null;
//   brandId: string;
//   brand: Brand | null;
//   name: string;
//   company: string;
//   brandLogoSrc: string | null;
//   brandImageSrc: string | null;
//   // avatarImageId: string;
//   avatarImageSrc: string | null;
//   unseen: boolean;
//   unreplied: boolean;
//   date: object | Date | null;
//   lastMessage: Message | null;
//   lastSenderCId: string;
//   loading: boolean;
//   asReads: string[];
//   asReadDateTimes: any[];
// }

export default Vue.extend({
  name: 'GChatBrandListItemContainer',
  props: {
    entry: {
      type: Object as PropType<Entry>,
      required: true,
    },
    buyer: {
      type: Object as PropType<PublicBuyer>,
      required: true,
    },
    buyerCompany: {
      type: Object as PropType<PublicBuyerCompany>,
      required: true,
    },
    exhibition: {
      type: Object as PropType<PublicExhibition>,
      required: true,
    },
    offline: {
      type: Object as PropType<PublicOffline>,
      required: true,
    },
    offlineDay: {
      type: Object as PropType<PublicOfflineDay>,
      required: true,
    },
    exhibitor: {
      type: Object as PropType<PublicExhibitor>,
      required: true,
    },
    exhibitorCompany: {
      type: Object as PropType<PublicExhibitorCompany>,
      required: true,
    },
  },
  // data(): DataType {
  //   return {
  //     exhibitorUID: '',
  //     exhibitorCID: null,
  //     buyerCID: null,
  //     brandId: '',
  //     brand: null,
  //     name: '',
  //     company: '',
  //     brandLogoSrc: '',
  //     brandImageSrc: '',
  //     // avatarImageId: '',
  //     avatarImageSrc: '',
  //     unseen: false,
  //     unreplied: false,
  //     date: null,
  //     lastMessage: null,
  //     lastSenderCId: '',
  //     loading: false,
  //     asReads: [],
  //     asReadDateTimes: [],
  //   };
  // },
  methods: {
    onClick() {
      this.$emit('click');
    },
    // async fetchContact() {
    //   try {
    //     this.loading = true;
    //     const res: Contact | null = await contact.load(this.contactID);
    //     if (!res || !res.data.exhibitor || !res.data.brandId) {
    //       throw new Error('datas is null:3');
    //     }
    //     this.buyerCID = res.data.buyer;
    //     this.exhibitorCID = res.data.exhibitor;
    //     this.brandId = res.data.brandId;
    //     this.asReads = res.data.asReads;
    //     this.asReadDateTimes = res.data.asReadDateTimes;
    //   } catch (err: any) {
    //     console.log(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async fetchBrand() {
    //   if (!this.brandId) return;
    //   try {
    //     this.loading = true;
    //     const res = await brand.load(this.brandId);
    //     if (!res || !res.data.base.staff) return;
    //     this.brand = res;
    //     this.exhibitorUID = res.data.base.staff;
    //   } catch (err: any) {
    //     console.log(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async fetchExhibitor() {
    //   if (!this.exhibitorUID || !this.exhibitorCID) return;
    //   try {
    //     this.loading = true;
    //     const resExhibitor = await exhibitor.load(this.exhibitorUID);
    //     if (!resExhibitor) throw Error('cant get exhibitor');

    //     this.name = resExhibitor.data.name;
    //     const resCompanyExhibitor = await companyExhibitor.load(
    //       this.exhibitorCID,
    //     );
    //     if (!resCompanyExhibitor) throw Error('cant get exhibitor company');

    //     this.company = resCompanyExhibitor.data.name;
    //     // this.avatarImageSrc = await genDownloadOriginalImageUrlEx(
    //     this.avatarImageSrc = await genDownloadImageUrlByImage(
    //       sizes.x512,
    //       resExhibitor.data.profileImage,
    //     );
    //     // if (
    //     //   !resExhibitor.data.profileImage
    //     //   || !resExhibitor.data.profileImage.id
    //     // ) return;
    //     // this.avatarImageId = resExhibitor.data.profileImage.id;
    //   } catch (err: any) {
    //     console.log(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // async fetchImages() {
    //   try {
    //     if (!this.brand) throw Error('Cant get brand');
    //     if (!this.exhibitorCID) throw Error('can not find this.exhibitorCID');

    //     this.brandLogoSrc = await genDownloadImageUrlByImage(
    //       sizes.x512,
    //       this.brand.data.base.logo,
    //     );
    //     this.brandImageSrc = await genDownloadImageUrlByImage(
    //       sizes.x512,
    //       this.brand.data.base.image,
    //     );

    //     // this.brandLogoSrc = await genDownloadOriginalImageUrlByImageEx(
    //     //   this.exhibitorCID,
    //     //   this.brand.data.base.logo,
    //     // );
    //     // this.brandImageSrc = await genDownloadOriginalImageUrlByImageEx(
    //     //   this.exhibitorCID,
    //     //   this.brand.data.base.image,
    //     // );
    //   } catch (err: any) {
    //     console.log(err);
    //   }
    // },
    // async fetchLastMessage() {
    //   try {
    //     if (!this.contactID || !this.buyerCID || !this.exhibitorCID) {
    //       throw new Error('datas is null:2');
    //     }
    //     this.loading = true;
    //     const res = await message.loadsByContactId(this.contactID, this.buyerCID, this.exhibitorCID);
    //     if (!res) return;
    //     if (!res.length) return;
    //     const lastMessage = res[res.length - 1];
    //     this.lastMessage = lastMessage;
    //     this.date = lastMessage.data.registeredDate;
    //     if (!lastMessage.data.senderCID) return;
    //     this.lastSenderCId = lastMessage.data.senderCID;
    //   } catch (err: any) {
    //     console.log(err);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // checkAsRead() {
    //   if (!this.lastMessage) {
    //     this.unseen = false;
    //     return;
    //   }
    //   const uid = this.$auth.uid;
    //   const seen = this.asReads.includes(uid);
    //   if (seen) {
    //     this.unseen = false;
    //     return;
    //   }
    //   this.unseen = true;
    // },
    // checUnreplied() {
    //   const uid = this.$auth.uid;
    //   const seen = this.asReads.includes(uid);
    //   const isExhibitorLast = this.lastSenderCId === this.exhibitorCID;
    //   if (seen && isExhibitorLast) {
    //     this.unreplied = true;
    //     return;
    //   }
    //   this.unreplied = false;
    // },
  },
  // async mounted() {
  //   await this.fetchContact();
  //   await this.fetchBrand();
  //   await this.fetchExhibitor();
  //   await this.fetchLastMessage();
  //   await this.fetchImages();
  //   this.checkAsRead();
  //   this.checUnreplied();
  // },
});
